import '../scss/main.scss';
import './animation';

window.addEventListener('scroll', function() {
  var element = document.getElementById('first'); // クラスを追加または削除したい要素のIDを指定してください
  if (window.scrollY === 0) {
    element.classList.remove('scroll-fade'); // クラスを削除したい場合、your-class-nameには削除したいクラス名を指定してください
  } else {
    element.classList.add('scroll-fade'); // クラスを追加したい場合、your-class-nameには追加したいクラス名を指定してください
  }
});

// 1番目から10番目の<section>要素に対して処理を実行
for (let i = 0; i < 10; i++) {
  const sectionNumber = i + 1;
  const sectionClass = `sec${sectionNumber}`;

  // セクション要素を取得
  const section = document.querySelectorAll('section')[i];

  if (section) {
    // 新しい要素を作成
    const deco1Element = document.createElement('div');
    deco1Element.className = `${sectionClass}-left-deco`;
    deco1Element.setAttribute('loading', 'lazy');

    const deco2Element = document.createElement('div');
    deco2Element.className = `${sectionClass}-right-deco`;
    deco2Element.setAttribute('loading', 'lazy');

    // 要素をセクション内に追加
    section.appendChild(deco1Element);
    section.appendChild(deco2Element);
  } else {
    console.error(`セクション ${sectionNumber} が見つかりませんでした。`);
  }
}

document.querySelector('.menu-button').addEventListener('click', () => {
  const closeButton = document.querySelector('.menu-list');
  closeButton.classList.toggle('close');
});